export default {
  MEDIA: '/media',
  EXT_MEDIA: '/ext-media',
  SOURCE: '/source',
  FEATURED: '/featured',
  FEATURED_CAROUSEL: '/carousel',
  THUMBNAIL: '/thumbnail',
  METADATA: '/metadata',
  CATEGORY: '/category',
  SEARCH: '/search',
  ADVANCED_SEARCH_FIELDS: '/advanced_search_field',
  METADATA_FIELDS: '/metadata-field',
  LANGUAGES: '/language',
  WHITELISTED_EMAIL_DOMAINS: '/whitelisted_email_domain',
  TAGS: '/tag',
  USERS: '/user',
  CHANNEL: '/channel',
  GROUPS: '/group',
  ADVANCED_QUERIES: '/advanced_query',
  PARTICIPANT: '/participant',
  SHARE: '/share',
  PLAYLIST: '/playlist',
  JOB: '/job',
  LIVE: '/live',

  FOLDERS: '/folder',
  MEMBERS: '/member',
  COMMENTS: '/comment',

  TIMEDATA: '/timedata',
  SEGMENT: '/segment',
  CC: '/cc',
  CHAPTERS: '/chapters',

  RELATED: '/related',

  UNAPPROVED_MEDIA: '/unapproved-media',

  QRCODE: '/qrcode',
  DOWNLOAD: '/download',
  STATISTICS: '/statistic',

  REPORTS: '/report',

  LOOKUP_TAGS: '/lookup/tag',
  LOOKUP_USERS: '/lookup/user',
  LOOKUP_GROUPS: '/lookup/group',
  LOOKUP_CATEGORIES: '/lookup/category',

  FOLLOWED: '/followed',
};
